import React, {useContext, useState} from "react";
import SignatureCanvas from "react-signature-canvas";
import axios from "axios";
import {Elink, SaveEsignsForPortal} from '../CommonComponents/Routes'
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";

export default (props) => {
    let RecordsController = useContext(RecordsManagementContext)
    let PageView = useContext(ViewMangementContext)
    let SignPad = {}
    const clear = () => {
        SignPad.clear()
    }
    // Safely get the sign id and signed_from
    const signId = typeof props.For === 'object' && props.For !== null ? props.For.id : props.For;
    const signedFrom = typeof props.For === 'object' && props.For !== null ? props.For.signed_from : undefined;
    const addendum_id = typeof props.For === 'object' && props.For !== null ? props.For.addendum_id : undefined;
    const saveSignature = async () => { // if signature is empty then it will show alert message
        if (SignPad.isEmpty()) {
            PageView.setAlertProperty({
                Message: 'Please Sign before Submit the Signature...!',
                Type: 'warning',
                Show: true,
                AutoHide: true
            })
        } else {  //post request is send to "save_esigns_for_portal" function in "client_portal_controller" to save esigns
            RecordsController.setSignatureLoad(true) //show loader
            RecordsController.setESignModal(false)
            document.getElementById(signId).setAttribute('style', 'display: none');
            let cookie = document.cookie.split('employee_id=')[1]
            await axios({
                method: 'post',
                url: SaveEsignsForPortal,
                contentType: "application/json",
                data: {
                    estimate_key: Elink,
                    employee_key: cookie,
                    type: signId,
                    signed_from: signedFrom,
                    addendum_id: addendum_id,
                    encoded_image: SignPad.toDataURL().replace('data:image/png;base64,', '')
                }
            }).then((response) => {//update the "company notes" and "company text" content in the page.
                PageView.setModalContent({Title: '', Body: '', Class: ''})
                let Message = response.data.Message
                PageView.setAlertProperty({Message: Message.Text, Type: Message.Type, Show: true, AutoHide: true})
                if (signedFrom === "EstimateAddendum") {
                    RecordsController.SetCP_PageDetails({
                        ...RecordsController.CP_PageDetails,
                        EstimateDetails: response.data.EstimateDetails,
                    });
                }
                 else {
                    PageView.setModalContent({Title: '', Body: '', Class: ''})
                    let Message = response.data.Message
                    PageView.setAlertProperty({Message: Message.Text, Type: Message.Type, Show: true, AutoHide: true})
                    RecordsController.SetCP_PageDetails({
                        ...RecordsController.CP_PageDetails,
                        CompanyNote: response.data.CompanyNotes,
                        EstimateAndCompanyInfo: {
                            ...RecordsController.CP_PageDetails.EstimateAndCompanyInfo,
                            CompanyText:response.data.CompanyText.CompanyText }
                    });
                }
            })
            RecordsController.setSignatureLoad(false); //hide the loader
        }
    }

    return (
        <div>
            <div className="border-5 shadow py-2 px-2">
                <SignatureCanvas penColor='black' ref={(ref) => {
                    SignPad = ref
                }}
                                 canvasProps={{width: 900, height: 230, className: 'EstimateSignPad'}}/>
            </div>
            <div className='footer-btn'>
                <button className="btn btn-light m-2" onClick={() => clear()}>CLEAR</button>
                    <button className="btn btn-primary"  onClick={() => saveSignature()}>Save Signature</button>

            </div>
        </div>
    )
}